import React, { useContext, useEffect, useState } from "react";

// MATERIAL
import { makeStyles } from "@mui/styles";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  Autocomplete,
  MenuItem,
} from "@mui/material";
import { Exposure } from "@mui/icons-material";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import clienteAxios from "../../../../config/axios";

const useStyles = makeStyles((theme) => ({
  inputPadding: {
    padding: theme.spacing(0.5),
    margin: theme.spacing(0),
    fontSize: "1rem",
  },
  formD: {
    flexGrow: 1,
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    width: "45%",

    [theme.breakpoints.down("md")]: {
      padding: "0",
      margin: "2px",
      width: "45%",
    },
  },
  formAllW: {
    flexGrow: 1,
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    width: "95%",

    [theme.breakpoints.down("md")]: {
      padding: "0",
      margin: "2px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0",
      margin: "2px",
    },
  },
}));

const CamposBusquedaConHorarios = (props) => {
  const {
    campoObjectItem,
    handleChange,
    fullBuscador,
    sethorarios,
    horarios,
    setfullBuscador,
  } = props;
  const clases = useStyles();
  const [expandirCampo, setexpandirCampo] = useState(
    Boolean(fullBuscador[`${campoObjectItem.propiedad}2`])
  );
  const [data, setdata] = useState(null);
  const [dataDinamica, setdataDinamica] = useState([]);
  const { mostrarAlerta } = useContext(AlertaContext);
  useEffect(() => {
    if (
      (campoObjectItem.variante === "autocompleteDataDefault" ||
        campoObjectItem.variante === "multipleSelectDataDefault") &&
      !data
    ) {
      const getData = async () => {
        console.log(campoObjectItem);

        const res = await campoObjectItem.getData(data);

        console.log({ res });
        console.log(" ASDAS AS A");

        setdata(res.data.data);
      };
      getData();
    }
    // eslint-disable-next-line
  }, []);
  if (campoObjectItem.variante === "multipleSelectDataDefault" && data) {
    return (
      <TextField
        label={`${campoObjectItem.label}`}
        value={fullBuscador[`${campoObjectItem.propiedad}`]}
        name={`${[campoObjectItem.propiedad]}`}
        onChange={async (e) => {
          if (["usuario"].includes(campoObjectItem.propiedad)) {
            if (e.target.value.length === 1) {
              const itemF = data.find((item) => {
                return item.perDocNumero === e.target.value[0]?.split("/+/")[0];
              });
              console.log({ itemF });
              const res =
                itemF &&
                (await clienteAxios.get(
                  `horarios/${itemF.perId}/ultimos_dias`
                ));
              console.log(fullBuscador);

              setfullBuscador((prev) => ({
                ...prev,
                horarios: "",
                [campoObjectItem.propiedad]: e.target.value,
              }));

              await sethorarios(
                res.data.map((item) => item.desde + " - " + item.hasta)
              );
            } else {
              sethorarios([]);
            }
            setfullBuscador((prev) => ({
              ...prev,
              horarios: "",
              [campoObjectItem.propiedad]: e.target.value,
            }));
          } else {
            handleChange(e);
          }
        }}
        className={clases.formAllW}
        select
        InputLabelProps={{ shrink: true }}
        SelectProps={{ displayEmpty: true, multiple: true }}
      >
        {data.map((item) => {
          return (
            <MenuItem dense value={item[campoObjectItem.campoData1]}>
              {campoObjectItem.propiedadesMostrar === 1
                ? item[campoObjectItem.campoData1]
                : item[campoObjectItem.campoData1] +
                  " - " +
                  item[campoObjectItem.campoData2]}
            </MenuItem>
          );
        })}
      </TextField>
    );
  }
  if (campoObjectItem.variante === "select") {
    return (
      <TextField
        label={`${campoObjectItem.label}`}
        value={fullBuscador[`${campoObjectItem.propiedad}`]}
        name={`${[campoObjectItem.propiedad]}`}
        onChange={(e) => handleChange(e)}
        className={clases.formAllW}
        select
        InputLabelProps={{ shrink: true }}
        SelectProps={{ displayEmpty: true }}
      >
        {campoObjectItem.options.map((item) => {
          return <MenuItem value={item.value}>{item.label} </MenuItem>;
        })}
      </TextField>
    );
  }
  if (campoObjectItem.variante === "autocompleteDinamico") {
    return (
      <>
        {" "}
        <Box className={clases.formAllW}></Box>
        <FormControl className={clases.formD}>
          <Autocomplete
            options={dataDinamica.map((item) => {
              return campoObjectItem.propiedadesMostrar === 1
                ? item[campoObjectItem.campoData1]
                : item[campoObjectItem.campoData1] +
                    "/+/" +
                    item[campoObjectItem.campoData2];
            })}
            getOptionLabel={(option) => {
              return campoObjectItem.propiedadesMostrar === 1
                ? option
                : option.replace("/+/", " ");
            }}
            id="controlled-demo"
            value={fullBuscador[`${campoObjectItem.propiedad}`]}
            name={`${[campoObjectItem.propiedad]}`}
            paperprops
            onChange={async (event, newValue) => {
              console.log({ newValue });

              if (!newValue) {
                return;
              }
              handleChange({
                target: {
                  name: `${[campoObjectItem.propiedad]}`,
                  value: newValue.split("/+/")[0],
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                onChange={async (e) => {
                  if (e.target.value === "") {
                    return mostrarAlerta("Ingrese un documento", "error");
                  }
                  try {
                    handleChange({
                      target: {
                        name: `${[campoObjectItem.propiedad]}`,
                        value: e.target.value,
                      },
                    });
                    const res = await campoObjectItem.getData(e.target.value);

                    if (!res.data.data) {
                      return mostrarAlerta(res.data.msg, "error");
                    }

                    setdataDinamica(res.data.data);
                  } catch (error) {}
                }}
                label={`${campoObjectItem.label}`}
                fullWidth
                InputProps={{
                  ...params.InputProps,
                  // endAdornment: (
                  //   <React.Fragment>
                  //     <IconButton
                  //

                  //       aria-label=""
                  //       onClick={async () => {
                  //         // seteditarProveedor(false);
                  //         setOpenProveedor(true);
                  //       }}
                  //     >
                  //       <AddCircleOutlineTwoTone color="primary" />
                  //     </IconButton>
                  //     {params.InputProps.endAdornment}
                  //   </React.Fragment>
                  // ),
                }}
              />
            )}
          />
        </FormControl>
      </>
    );
  }
  if (campoObjectItem.variante === "autocompleteComun") {
    return (
      <>
        <Box className={clases.formAllW}></Box>
        <FormControl className={clases.formD}>
          <Autocomplete
            options={campoObjectItem.data.map((item) => {
              return item;
            })}
            getOptionLabel={(option) => {
              return option;
            }}
            id="controlled-demo"
            value={fullBuscador[`${campoObjectItem.propiedad}`] ?? null}
            paperprops
            onChange={async (event, newValue) => {
              handleChange({
                target: {
                  name: `${[campoObjectItem.propiedad]}`,
                  value: newValue,
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                label={`${campoObjectItem.label}`}
                fullWidth
                InputProps={{
                  ...params.InputProps,
                  // endAdornment: (
                  //   <React.Fragment>
                  //     <IconButton
                  //

                  //       aria-label=""
                  //       onClick={async () => {
                  //         // seteditarProveedor(false);
                  //         setOpenProveedor(true);
                  //       }}
                  //     >
                  //       <AddCircleOutlineTwoTone color="primary" />
                  //     </IconButton>
                  //     {params.InputProps.endAdornment}
                  //   </React.Fragment>
                  // ),
                }}
              />
            )}
          />
        </FormControl>
      </>
    );
  }

  if (campoObjectItem.variante === "autocompleteDataDefault" && data) {
    return (
      <>
        <Box className={clases.formAllW}></Box>
        <FormControl className={clases.formD}>
          <Autocomplete
            options={data.map((item) => {
              return campoObjectItem.propiedadesMostrar === 1
                ? item[campoObjectItem.campoData1]
                : item[campoObjectItem.campoData1] +
                    "/+/" +
                    item[campoObjectItem.campoData2];
            })}
            getOptionLabel={(option) => {
              return campoObjectItem.propiedadesMostrar === 1
                ? option
                : option.replace("/+/", " ");
            }}
            id="controlled-demo"
            value={fullBuscador[`${campoObjectItem.propiedad}`]}
            name={`${[campoObjectItem.propiedad]}`}
            paperprops
            onChange={async (event, newValue) => {
              if (
                ["usuario", "cajaUser", "venUser"].includes(
                  campoObjectItem.propiedad
                )
              ) {
                const itemF = data.find((item) => {
                  return item.perDocNumero === newValue.split("/+/")[0];
                });
                console.log({ itemF });
                const res = await clienteAxios.get(
                  `horarios/${itemF.perId}/ultimos_dias`
                );
                console.log(fullBuscador);

                setfullBuscador((prev) => ({
                  ...prev,
                  horarios: "",
                  [campoObjectItem.propiedad]: newValue.split("/+/")[0],
                }));
                await sethorarios(
                  res.data.map((item) => item.desde + " - " + item.hasta)
                );
              }
              setfullBuscador((prev) => ({
                ...prev,
                [campoObjectItem.propiedad]: newValue.split("/+/")[0],
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                label={`${campoObjectItem.label}`}
                fullWidth
                InputProps={{
                  ...params.InputProps,
                  // endAdornment: (
                  //   <React.Fragment>
                  //     <IconButton
                  //

                  //       aria-label=""
                  //       onClick={async () => {
                  //         // seteditarProveedor(false);
                  //         setOpenProveedor(true);
                  //       }}
                  //     >
                  //       <AddCircleOutlineTwoTone color="primary" />
                  //     </IconButton>
                  //     {params.InputProps.endAdornment}
                  //   </React.Fragment>
                  // ),
                }}
              />
            )}
          />
        </FormControl>
      </>
    );
  }
  return (
    <>
      <Box className={clases.formAllW}></Box>
      {campoObjectItem.tipo === "fecha" ? (
        <>
          <TextField
            InputLabelProps={{ shrink: true }}
            type="date"
            className={clases.formD}
            label={`${campoObjectItem.label} ${expandirCampo ? "- Desde" : ""}`}
            value={fullBuscador[`${campoObjectItem.propiedad}1`]}
            name={`${[campoObjectItem.propiedad]}1`}
            onChange={(e) => handleChange(e)}
            InputProps={{
              endAdornment: (
                <InputAdornment>
                  {!expandirCampo ? (
                    <IconButton
                      aria-label=""
                      onClick={() => {
                        setexpandirCampo(true);
                      }}
                    >
                      <Exposure color="primary" />
                    </IconButton>
                  ) : null}
                </InputAdornment>
              ),
            }}
          />{" "}
          {expandirCampo ? (
            <TextField
              InputLabelProps={{ shrink: true }}
              type="date"
              className={clases.formD}
              label={`${campoObjectItem.label} - Hasta`}
              value={fullBuscador[`${campoObjectItem.propiedad}2`]}
              name={`${[campoObjectItem.propiedad]}2`}
              onChange={(e) => handleChange(e)}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton
                      aria-label=""
                      onClick={() => {
                        setexpandirCampo(false);
                        setfullBuscador((prev) => ({
                          ...prev,
                          [`${campoObjectItem.propiedad}2`]: "",
                        }));
                      }}
                    >
                      <Exposure color="error" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          ) : null}
        </>
      ) : campoObjectItem.tipo === "fecha-hora" ? (
        <>
          <TextField
            InputLabelProps={{ shrink: true }}
            type="datetime-local"
            className={clases.formD}
            label={`${campoObjectItem.label} ${expandirCampo ? "- Desde" : ""}`}
            value={fullBuscador[`${campoObjectItem.propiedad}1`]}
            name={`${[campoObjectItem.propiedad]}1`}
            onChange={(e) => handleChange(e)}
            InputProps={{
              endAdornment: (
                <InputAdornment>
                  {!expandirCampo ? (
                    <IconButton
                      aria-label=""
                      onClick={() => {
                        setexpandirCampo(true);
                      }}
                    >
                      <Exposure color="primary" />
                    </IconButton>
                  ) : null}
                </InputAdornment>
              ),
            }}
          />{" "}
          {expandirCampo ? (
            <TextField
              InputLabelProps={{ shrink: true }}
             type="datetime-local"
              className={clases.formD}
              label={`${campoObjectItem.label} - Hasta`}
              value={fullBuscador[`${campoObjectItem.propiedad}2`]}
              name={`${[campoObjectItem.propiedad]}2`}
              onChange={(e) => handleChange(e)}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton
                      aria-label=""
                      onClick={() => {
                        setexpandirCampo(false);
                        setfullBuscador((prev) => ({
                          ...prev,
                          [`${campoObjectItem.propiedad}2`]: "",
                        }));
                      }}
                    >
                      <Exposure color="error" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          ) : null}
        </>
      ) : campoObjectItem.tipo === "string" ? (
        <>
          <TextField
            className={clases.formD}
            label={`${campoObjectItem.label}`}
            value={fullBuscador[`${campoObjectItem.propiedad}`]}
            name={`${[campoObjectItem.propiedad]}`}
            onChange={(e) => handleChange(e)}
          />
        </>
      ) : campoObjectItem.tipo === "numero" ? (
        <>
          <TextField
            type={"number"}
            className={clases.formD}
            label={`${campoObjectItem.label} ${expandirCampo ? "- Desde" : ""}`}
            value={fullBuscador[`${campoObjectItem.propiedad}1`]}
            name={`${[campoObjectItem.propiedad]}1`}
            onChange={(e) => handleChange(e)}
            InputProps={{
              endAdornment: (
                <InputAdornment>
                  {!expandirCampo ? (
                    <IconButton
                      aria-label=""
                      onClick={() => {
                        setexpandirCampo(true);
                      }}
                    >
                      <Exposure color="primary" />
                    </IconButton>
                  ) : null}
                </InputAdornment>
              ),
            }}
          />{" "}
          {expandirCampo ? (
            <TextField
              type={"number"}
              className={clases.formD}
              label={`${campoObjectItem.label} - Hasta`}
              value={fullBuscador[`${campoObjectItem.propiedad}2`]}
              name={`${[campoObjectItem.propiedad]}2`}
              onChange={(e) => handleChange(e)}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton
                      aria-label=""
                      onClick={() => {
                        setexpandirCampo(false);
                        setfullBuscador((prev) => ({
                          ...prev,
                          [`${campoObjectItem.propiedad}2`]: "",
                        }));
                      }}
                    >
                      <Exposure color="error" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          ) : null}
        </>
      ) : campoObjectItem.tipo === "hora" ? (
        <>
          <TextField
            InputLabelProps={{ shrink: true }}
            type="time"
            className={clases.formD}
            label={`${campoObjectItem.label} ${expandirCampo ? "- Desde" : ""}`}
            value={fullBuscador[`${campoObjectItem.propiedad}1`]}
            name={`${[campoObjectItem.propiedad]}1`}
            onChange={(e) => handleChange(e)}
            InputProps={{
              endAdornment: (
                <InputAdornment>
                  {!expandirCampo ? (
                    <IconButton
                      aria-label=""
                      onClick={() => {
                        setexpandirCampo(true);
                      }}
                    >
                      <Exposure color="primary" />
                    </IconButton>
                  ) : null}
                </InputAdornment>
              ),
            }}
          />{" "}
          {expandirCampo ? (
            <TextField
              InputLabelProps={{ shrink: true }}
              type="time"
              className={clases.formD}
              label={`${campoObjectItem.label} - Hasta`}
              value={fullBuscador[`${campoObjectItem.propiedad}2`]}
              name={`${[campoObjectItem.propiedad]}2`}
              onChange={(e) => handleChange(e)}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton
                      aria-label=""
                      onClick={() => {
                        setexpandirCampo(false);
                        setfullBuscador((prev) => ({
                          ...prev,
                          [`${campoObjectItem.propiedad}2`]: "",
                        }));
                      }}
                    >
                      <Exposure color="error" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default CamposBusquedaConHorarios;
